import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function initSwiper(el: string) {
    let options;
    if (el === '.swiper-testimonials' || el === '.swiper-tips' || el === '.swiper-steps') {
        options = {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            autoHeight: true,
            grid: {
                rows: 2,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    autoHeight: false,
                }
            },
            navigation: {
                nextEl: el + " .swiper-next",
                prevEl: el + " .swiper-prev",
            },
            pagination: {
                el: el + ' .swiper-dots',
                clickable: true,
            }
        };
    } else if (el === '.swiper-specialists-single') {
        options = {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 5000,
            },
        };
    } else if (el === '.swiper-top-profiles') {
        options = {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            autoHeight: true,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    autoHeight: false,
                }
            },
            navigation: {
                nextEl: el + " .swiper-next",
                prevEl: el + " .swiper-prev",
            },
            pagination: {
                el: el + ' .swiper-dots',
                clickable: true,
            }
        };
    } else {
        options = {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoHeight: true,
            grid: {
                rows: 2,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    autoHeight: false,
                }
            },
            navigation: {
                nextEl: el + " .swiper-next",
                prevEl: el + " .swiper-prev",
            },
            pagination: {
                el: el + ' .swiper-dots',
                clickable: true,
            },
        };
    }

    new Swiper(el, options);
}
